import Loadable from 'react-loadable';

const LoyaltyWidget = Loadable({
  loader: () => import(/* webpackChunkName: "LoyaltyWidget" */ './LoyaltyWidget'),
  modules: ['./LoyaltyWidget'],
  loading: () => null
});

export default LoyaltyWidget;
